import './assets/scss/common.scss';
import './index.scss';

import React from 'react';
import { render } from 'react-dom';

import App from './App';
import Config from './config';
import { bootstrapPwaClientGuards } from './features/pwa';
import { mountPwaBootSplash } from './features/pwa/utils/pwaBootSplash';

const rootEL = document.getElementById('root');

// expose primary color as CSS variable for global styles (e.g., scrollbars)
document.documentElement.style.setProperty('--global-primary-color', Config.GLOBAL_PRIMARY_COLOR);

bootstrapPwaClientGuards();

// Installed PWA only: show logo + site name immediately while the app boots.
mountPwaBootSplash();

const AppEl =
    process.env.NODE_ENV !== 'production' ? (
        <React.StrictMode>
            <App />
        </React.StrictMode>
    ) : (
        <App />
    );

render(AppEl, rootEL);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
process.env.NODE_ENV !== 'production' && import('./reportWebVitals').then((v) => v.default());
